import { baseApi } from 'sama-shared';
import type { PayoutAccountBank } from '../payout-account/types/payout-account';

/**
 * Catálogo de bancos (`Bank`).
 *
 * El módulo `delivery-payout-account` solo guarda `bankId`; el nombre y el
 * código del banco llegan como relación en cada cuenta, pero el selector del
 * modal de creación/edición necesita el catálogo completo.
 *
 * Se reutiliza el endpoint público `/public/finance/banks` (el mismo que usa
 * `sama-partner`), que no requiere scoping por tienda ni partner.
 */
export const deliveryBanksApi = baseApi
  .enhanceEndpoints({ addTagTypes: ['Bank'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getDeliveryBanks: builder.query<PayoutAccountBank[], void>({
        query: () => ({
          url: '/public/finance/banks',
          method: 'GET',
        }),
        transformResponse: (response: unknown): PayoutAccountBank[] => {
          if (Array.isArray(response)) return response as PayoutAccountBank[];
          if (response && Array.isArray((response as any).data))
            return (response as any).data as PayoutAccountBank[];
          if (response && Array.isArray((response as any).banks))
            return (response as any).banks as PayoutAccountBank[];
          return [];
        },
        providesTags: [{ type: 'Bank', id: 'LIST' }],
      }),
    }),
    overrideExisting: false,
  });

export const { useGetDeliveryBanksQuery } = deliveryBanksApi;
